import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//wflow样式文件
import './assets/theme.css'
import './assets/global.css'

import QiniuUploader from '@/utils/qiniu'
import {Icon} from '@iconify/vue'
import * as ElIcons from '@element-plus/icons-vue'
import * as utils from '@/utils/utils'; // 导入所有方法
import 'normalize.css/normalize.css'
import '@/style/common.scss'
import 'default-passive-events'

// import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
// 企业微信包
// import * as ww from '@wecom/jssdk'
import 'dayjs/locale/zh-cn'

import Directives from '@/directives'
import rizhiNew from '@/components/rizhi/rizhi_new.vue'
// export const Bus = new Vue()
// const baseSize = 50
// // 设置 rem 函数
// function setRem () {
//   // 当前页面宽度相对于 750 宽的缩放比例，可根据自己需要修改。
//   const scale = document.documentElement.clientWidth / 750
//   // 设置页面根节点字体大小
//   document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
// }
// // 初始化
// setRem()
// // 改变窗口大小时重新设置 rem
// window.onresize = function () {
//   setRem()
// }


let openMock = false

// import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// use(ElementPlus).

// const app = createApp()
// for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
//   app.component(key, component)
// }
const app = createApp(App)
for (const [key, component] of Object.entries(ElIcons)) {
  app.component(key, component)
}
app.config.globalProperties.$utils = utils; // 方式一：挂载整个工具对象
// .provide('ww',ww)

app.component('iconify',Icon).component('rizhiNew', rizhiNew).use(Directives).use(store).use(router).use(QiniuUploader).mount('#app')